import React, {useState} from "react";
import CvProtocol from "./CvProtocol";
import Programmer from "./Programmer";
import {getDccProtocol, getNode} from "./CvParser";



const CvEditor = ({data}) => {

    //const r0 = getNode(data, "decoderFirmwareDefinition")
    //console.log(r0)

    //const r1 = getNode(r0, "firmware")
    //console.log(r1)

    //const r2 = getNode(r1, "protocol")
    //console.log(r2)

    console.log(data)

    const x0 = data?.decoderFirmwareDefinition?.firmware?.protocols?.protocol[0]
    //console.log(x0)

    return(
        <div style={{
            display: "flex",
            overflow: 'visible',
        }}>
            <CvProtocol data={x0}/>
        </div>
    )
}

export default CvEditor
